<div class="mb-3">
  <label class="form-label" *ngIf="hasLabel" [attr.for]="resolvedInputId">
    {{ label | translate }} <span *ngIf="required && !disabled"> * </span>
  </label>

  <ng-container *ngIf="!disabled">
    <input
      type="date"
      class="form-control"
      [formControl]="field"
      [required]="required && !disabled"
      [min]="minDateString"
      [max]="maxDateString"
      [attr.id]="resolvedInputId"
    />
  </ng-container>

  <ng-container *ngIf="disabled">
    <input
      class="form-control"
      type="date"
      [value]="field.value"
      readonly
      disabled
      [attr.id]="resolvedInputId"
    />
  </ng-container>

  <div *ngIf="showError" class="form-text text-danger">
    <ng-container *ngIf="field.errors?.minDate">
      {{ ('field.datepicker.minDate' | translate) + minDateFormatted + ('field.datepicker.closeText' | translate ) }}
    </ng-container>
    <ng-container *ngIf="field.errors?.maxDate">
      {{ ('field.datepicker.maxDate' | translate) + maxDateFormatted + ('field.datepicker.closeText' | translate ) }}
    </ng-container>
    <ng-container *ngIf="!field.errors?.minDate && !field.errors?.maxDate">
      {{ error | translate }}
    </ng-container>
  </div>
</div>
